/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
import React, { useCallback } from 'react';
import _ from 'lodash';
import {
    ModalNextProvider,
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import PropTypes from 'prop-types';
import { LocaleService } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import styles from './iAmDropdownModal.module.scss';
import UtilService from '../../services/UtilService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function IAmDropdownModal(props) {
    const {
        isOpen,
        onResolve,
        modalTitle,
        modalDescription,
        continueButtonText,
        leaveButtonText
    } = props;
    const auth = useAuthentication();
     const history = useHistory();

    const onContinueClick = () => {
        window.location.href = UtilService.getBusinessInfoUrl(LocaleService.getStoredLanguage());
    }

    const handleClose = () => {
        onResolve('close');
        onResolve(); 
    }

    return (
        <ModalNext
            isOpen={isOpen}
            shouldCloseOnOverlayClick={false}
            ariaLabelledby="sessionExpiryHeader"
            ariaDescribedby="sessionExpiryDescription"
            className={styles.modalContainer}
            onRequestClose={() => handleClose()}
        >
            <ModalHeader title={<h2 id="sessionExpiryHeader" className={styles.diModalHeader}>{modalTitle}</h2>} />
            <ModalBody>
                <p id="sessionExpiryDescription" className={styles.diModalContent}>{modalDescription}</p>
            </ModalBody>
            <ModalFooter>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Button
                        id="sessionPriButton"
                        className={`${styles.normalSpace} ${styles.continueButton}`}
                        type="primary"
                        onClick={() => {
                            onContinueClick();
                            onResolve();
                        }}
                    >
                        {continueButtonText}
                    </Button>
                    <Button
                        id="sessionPriButton"
                        className={styles.normalSpace}
                        type="secondary"
                        onClick={handleClose}
                    >
                        {leaveButtonText}
                    </Button>
                </div>
            </ModalFooter>
        </ModalNext>
    );
}

function IAmDropdownPopupModal(modalTitle, modalDescription, continueButtonText, leaveButtonText) {
    return ModalNextProvider.showModal(
        <IAmDropdownModal
            modalTitle={modalTitle}
            modalDescription={modalDescription}
            continueButtonText={continueButtonText}
            leaveButtonText={leaveButtonText}
        />
    ).then((result) => {
        console.log(`Dialog closed: ${result}`);
        
        return 'Ill or Injured';
    });
}

export default IAmDropdownPopupModal;
